import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const CookiesConsentModal = () => {
    const [show, setShow] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [activeTab, setActiveTab] = useState('Consent');

    const [switches, setSwitches] = useState({
        Necessary: true,
        Preferences: false,
        Statistics: false,
        Marketing: false,
    });

    useEffect(() => {
        const accepted = localStorage.getItem('cookieConsent');
        if (!accepted) {
            setShow(true);
        }
    }, []);

    const handleAllowAll = () => {
        const allEnabled = {
            Necessary: true,
            Preferences: true,
            Statistics: true,
            Marketing: true,
        };
        localStorage.setItem('cookieConsent', JSON.stringify(allEnabled));
        setShow(false);
    };

    const handleAllowSelection = () => {
        localStorage.setItem('cookieConsent', JSON.stringify(switches));
        setShow(false);
    };

    const handleDeny = () => {
        const denied = {
            Necessary: true,
            Preferences: false,
            Statistics: false,
            Marketing: false,
        };
        localStorage.setItem('cookieConsent', JSON.stringify(denied));
        setShow(false);
    };

    const toggleCategory = (category) => {
        if (category === 'Necessary') return;
        setSwitches((prev) => ({
            ...prev,
            [category]: !prev[category],
        }));
    };

    return (
        <>
        <style>
            {`
            .about-cookies p{
                color: black !important;
                margin-bottom: 0rem;
                line-height: 1.2;
            }
            .about-cookies h5{
                color: black !important;
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
                line-height: 1.2;
            }
                .accordion-button::before {
                    display: none !important;
                }

                .accordion-button .fa-chevron-down {
                    transition: transform 0.3s ease;
                }

                .accordion-button:not(.collapsed) .fa-chevron-down {
                    transform: rotate(180deg);
                }
                .accordion-button.no-arrow::after {
                   display: none;
                }
                .bg-black{
                    background-color: #000000 !important;
                }
                    p{
                        color: black !important;
                        text-align: justify;
                    }
               
            `}
        </style>
            {/* Cookie Bar (only show when details modal is hidden) */}
            {!showDetails && show && (
                <div
                    className="position-fixed bottom-0 start-0 w-100 bg-black text-white px-4 py-3"
                    style={{
                        borderTopLeftRadius: '20px',
                        borderTopRightRadius: '20px',
                        zIndex: 1050,
                        fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`,
                    }}
                >
                    <div className="container">
                        <div className="row gy-3">
                            <div className="col-md-9">
                                <h2 className="mb-2 fw-bold" style={{ color: '#E6178B', textAlign: 'justify' }}>
                                    This website uses cookies
                                </h2>
                                <p className="large mb-3 text-light">
                                    At Radius Exhibition Fixtures, we are committed to protecting your privacy. This Cookie Policy explains how we use cookies and similar technologies on our website: www.Radius.com.
                                    By using our website, you agree to our use of cookies as described in this policy.

                                </p>


                                <div className="d-flex flex-wrap gap-3 mt-2">
                                    {Object.entries(switches).map(([category, value]) => (
                                        <div
                                            className="d-flex align-items-center bg-opacity-10 rounded-pill"
                                            key={category}
                                            style={{ minWidth: '100px' }}
                                        >
                                            <div className="form-check form-switch m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id={`switch-${category}`}
                                                    checked={value}
                                                    onChange={() => toggleCategory(category)}
                                                    disabled={category === 'Necessary'}
                                                    style={{
                                                        width: '3.2rem',
                                                        height: '2.2rem',
                                                        cursor: category === 'Necessary' ? 'not-allowed' : 'pointer',
                                                    }}
                                                />
                                            </div>
                                            <label
                                                className="form-check-label ms-1 mb-0 text-white"
                                                htmlFor={`switch-${category}`}
                                                style={{ fontSize: '1rem',marginTop: '0.2rem' }}
                                            >
                                                {category}
                                                {category === 'Necessary' && ' (Required)'}
                                            </label>
                                        </div>
                                    ))}
                                    <button
                                        className="btn btn-link btn-lg text-decoration-none ps-0 mt-1"
                                        style={{ color: '#E6178B' }}
                                        onClick={() => setShowDetails(true)}
                                    >
                                        Show Details <i className="fas fa-angle-right"></i>
                                    </button>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="d-flex flex-column gap-2 mt-5">
                                    <button className="btn btn-warning bg-pink btn-lg px-4"   onClick={handleAllowAll}>
                                        Allow All
                                    </button>
                                    <button className="btn btn-outline-light btn-lg px-4" onClick={handleAllowSelection}>
                                        Allow Selection
                                    </button>
                                    <button className="btn btn-outline-secondary btn-lg px-4" onClick={handleDeny}>
                                        Deny
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal */}
            {showDetails && (
                <div
                    className="modal fade show d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        zIndex: 1060,
                    }}
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Cookie Preferences</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowDetails(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {/* Tabs */}
                                <ul className="nav nav-tabs mb-3">
                                    {['Consent', 'Details', 'About'].map((tab) => (
                                        <li className="nav-item" key={tab} style={{ width: '33.33%' }}>
                                            <button
                                                className={`nav-link text-dark ${activeTab === tab ? 'border-bottom border-3 border-warning fw-bold' : ''}`}
                                                style={{
                                                    border: 'none',
                                                    background: 'transparent',
                                                    width: '100%',
                                                    padding: '10px 0',
                                                    fontSize: '16px',
                                                }}
                                                onClick={() => setActiveTab(tab)}
                                            >
                                                {tab}
                                            </button>
                                        </li>
                                    ))}
                                </ul>


                                {/* Tab Content */}
                                {activeTab === 'Consent' && (
                                    <>
                                        <h4 className="mb-3 text-justify">Cookie Preferences</h4>
                                        <p className='text-black'>We use cookies to personalise content and ads, to provide social media features and to analyse our traffic. We also share information about your use of our site with our social media, advertising and analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.</p>
                                        <div className="container">
                                            <div className="row d-flex flex-wrap gap-3">
                                                {Object.entries(switches).map(([category, value]) => (
                                                    <div
                                                        className=" d-flex align-items-center justify-content-between border rounded px-3 py-2"
                                                        key={category}
                                                        style={{
                                                            background: '#f8f9fa',
                                                            width: '250px',
                                                            height: '100px',
                                                        }}
                                                    >
                                                        <label
                                                            className="form-check-label mb-0"
                                                            htmlFor={`modal-switch-${category}`}
                                                            style={{ fontWeight: 500 }}
                                                        >
                                                            {category} {category === 'Necessary' && '(Required)'}
                                                        </label>
                                                        <div className="form-check form-switch m-0">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`modal-switch-${category}`}
                                                                checked={value}
                                                                onChange={() => toggleCategory(category)}
                                                                disabled={category === 'Necessary'}
                                                            />
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>



                                    </>
                                )}

                                {activeTab === 'Details' && (
                                    <div className="accordion" id="cookieAccordion">
                                        {[
                                            {
                                                category: 'Necessary',
                                                description:
                                                    'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
                                                count: 8,
                                                providers: [
                                                    {
                                                        name: 'Cookiebot',
                                                        cookies: [
                                                            {
                                                                name: 'CookieConsent',
                                                                purpose: "Stores the user's cookie consent state.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },
                                                            
                                                        ],
                                                    },
                                                    {
                                                        name: 'Google',
                                                        cookies: [
                                                            {
                                                                name: 'test_cookie',
                                                                purpose: "Some of the data collected by this provider is for the purposes of personalization and measuring advertising effectiveness.",
                                                                duration: '1 Day',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    }, 
                                                    {
                                                        name: 'LinkedIn',
                                                        cookies: [
                                                            {
                                                                name: 'bcookie',
                                                                purpose: "Used in order to detect spam and improve the website's security.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'Vimeo',
                                                        cookies: [
                                                            {
                                                                name: '__cf_bm',
                                                                purpose: "This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                category: 'Preferences',
                                                description:
                                                    'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language or the region that you are in.',
                                                count: 3,
                                                providers: [
                                                    {
                                                        name: 'Google',
                                                        cookies: [
                                                            {
                                                                name: '_ga',
                                                                purpose: "Registers a unique ID that is used to generate statistical data on how the visitor uses the website.",
                                                                duration: '2 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'Hotjar',
                                                        cookies: [
                                                            {
                                                                name: 'hjActiveViewportIds',
                                                                purpose: "This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.",
                                                                duration: 'Persistent',
                                                                type: 'HTML Local Storage',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'Leadinfo',
                                                        cookies: [
                                                            {
                                                                name: 'snowplowOutQueue_#_post2',
                                                                purpose: "Registers statistical data on users' behaviour on the website. Used for internal analytics by the website operator.",
                                                                duration: 'Persistent',
                                                                type: 'HTML Local Storage',
                                                            }, {
                                                                name: 'hjViewportId',
                                                                purpose: "Saves the user's screen size in order to adjust the size of images on the website.",
                                                                duration: 'Session',
                                                                type: 'HTML Local Storage',
                                                            },
                                                            {
                                                                name: '_hjSession_#',
                                                                purpose: "Collects statistics on the visitor's visits to the website, such as the number of visits, average time spent on the website and what pages have been read.",
                                                                duration: '1 day',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'Vimeo',
                                                        cookies: [
                                                            {
                                                                name: 'vuid',
                                                                purpose: "Collects data on the user's visits to the website, such as which pages have been read.",
                                                                duration: '2 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                category: 'Statistics',
                                                description:
                                                    'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
                                                count: 10,
                                                providers: [
                                                    {
                                                        name: 'Cookiebot',
                                                        cookies: [
                                                            {
                                                                name: 'CookieConsent',
                                                                purpose: "Stores the user's cookie consent state.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'Google',
                                                        cookies: [
                                                            {
                                                                name: 'test_cookie',
                                                                purpose: "Some of the data collected by this provider is for the purposes of personalization and measuring advertising effectiveness.",
                                                                duration: '1 Day',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'LinkedIn',
                                                        cookies: [
                                                            {
                                                                name: 'bcookie',
                                                                purpose: "Used in order to detect spam and improve the website's security.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                    {
                                                        name: 'Vimeo',
                                                        cookies: [
                                                            {
                                                                name: '__cf_bm',
                                                                purpose: "This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make valid reports on the use of their website.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },

                                                        ],
                                                    },
                                                ],
                                            },
                                            {
                                                category: 'Marketing',
                                                description:
                                                    'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.',
                                                count: 28,
                                                providers: [
                                                    {
                                                        name: 'Google',
                                                        cookies: [
                                                            {
                                                                name: 'Google',
                                                                purpose: "Some of the data collected by this provider is for the purposes of personalization and measuring advertising effectiveness.",
                                                                duration: '1 year',
                                                                type: 'HTTP Cookie',
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        name: 'Leadinfo',
                                                        cookies: [
                                                            {
                                                                name: '_li_id.#',
                                                                purpose: "Tracks the individual sessions on the website, allowing the website to compile statistical data from multiple visits. This data can also be used to create leads for marketing purposes.",
                                                                duration: 'Persistent',
                                                                type: 'HTML Local Storage',
                                                            },
                                                        ],
                                                    },
                                                    {
                                                        name: 'YouTube',
                                                        cookies: [
                                                            {
                                                                name: '#-#',
                                                                purpose: "Used to track user’s interaction with embedded content.",
                                                                duration: 'Session',
                                                                type: 'HTML Local Storage',
                                                            },
                                                        ],
                                                    },
                                                ],
                                            },
                                        ].map((item, index) => (
                                            <div className="accordion-item" key={item.category}>
                                                {/* Level 1 - Category */}
                                                <h2 className="accordion-header" id={`heading-${index}`}>
                                                    <button
                                                        className="accordion-button  no-arrow  collapsed d-flex align-items-center justify-content-between"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target={`#collapse-${index}`}
                                                        aria-expanded="false"
                                                        aria-controls={`collapse-${index}`}
                                                    >
                                                        <div className="d-flex align-items-center">
                                                            <i className="fas fa-chevron-down me-2"></i>
                                                            <span className="fw-bold">{item.category}</span>
                                                        </div>
                                                        <div className="form-check form-switch m-0">
                                                            <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                id={`switch-${index}`}
                                                                checked={true}
                                                                disabled={item.category === 'Necessary'}
                                                                onChange={() => { }}
                                                            />
                                                        </div>
                                                    </button>
                                                </h2>
                                                <div
                                                    id={`collapse-${index}`}
                                                    className="accordion-collapse collapse"
                                                    aria-labelledby={`heading-${index}`}
                                                    data-bs-parent="#cookieAccordion"
                                                >
                                                    <div className="accordion-body">
                                                        <p style={{ textAlign: 'justify' }}>{item.description}</p>

                                                        {/* Level 2 - Providers */}
                                                        <div className="accordion" id={`providerAccordion-${index}`}>
                                                            {item.providers.map((provider, pIndex) => (
                                                                <div className="accordion-item" key={provider.name}>
                                                                    <h2 className="accordion-header" id={`providerHeading-${index}-${pIndex}`}>
                                                                        <button
                                                                            className="accordion-button collapsed"
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target={`#providerCollapse-${index}-${pIndex}`}
                                                                            aria-expanded="false"
                                                                            aria-controls={`providerCollapse-${index}-${pIndex}`}
                                                                        >
                                                                            {provider.name}
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id={`providerCollapse-${index}-${pIndex}`}
                                                                        className="accordion-collapse collapse"
                                                                        aria-labelledby={`providerHeading-${index}-${pIndex}`}
                                                                        data-bs-parent={`#providerAccordion-${index}`}
                                                                    >
                                                                        <div className="accordion-body">
                                                                            <ul className="list-unstyled mb-0" style={{ textAlign: 'justify' }}>
                                                                                {provider.cookies.map((cookie, cIndex) => (
                                                                                    <li key={cIndex} className="mb-2 border-bottom pb-2">
                                                                                        <strong>{cookie.name}</strong>
                                                                                        <p className="mb-1">{cookie.purpose}</p>
                                                                                        <small>
                                                                                            <strong>Duration:</strong> {cookie.duration}
                                                                                            <br />
                                                                                            <strong>Type:</strong> {cookie.type}
                                                                                        </small>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {/* End Providers */}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}





                                {activeTab === 'About' && (
                                    <div class="about-cookies" style={{ textAlign: 'justify', fontSize: '16px', lineHeight: '1.6' ,color:'black'}}>
                                        <p>
                                            Radius is Interior Fit Out Company in Dubai which established in 2007 and built on a legacy of uncompromising craftsmanship and world-class project management, Our divisions; Event Production, Exhibition Stand Fabrication, Interior Fit-outs, Signage, Large Format Printing & Branding are led by passionate experts in their field, With a focus on finding creative solutions on every aspect of your events, from strategic planning to finding venues and creating immersive experiences.
                                        </p>
                                        <p>
                                            e organize memorable events in various sectors including healthcare, technology, finance, energy, engineering… “Original concepts and impeccable execution” is what RADIUS promise. Whatever you are looking for, no matter what your event production works, exhibition, interior fit-outs, printing or signage needs are, we will be able to provide creative solutions.
                                        </p>
                                        
                                        {/* <h5>Areas of application</h5>
                                        <p>This website and associated cookies are managed by Radius B.V. with registered office Steenoven 2, Tricht (The Netherlands) with Crossroads Bank of Companies number 301.282.45.</p>
                                        <p>We act as data controller when we process the personal data from the users of our online environment using cookies.
                                        </p>
                                        <p>We act in compliance with the applicable regulations relating to data protection such as General Data Protection Regulation no. 2016/679 (GDPR) and national laws relating to data protection. These regulations concern the protection of your personal data and give you rights with respect to the personal data.</p>
                                        <p>The purpose of this policy is to explain which personal data we collect using cookies and how we use your data after you have visited our website using a desktop computer, tablet, smartphone or other medium on which the cookies are installed.</p>
                                        <h5>What are cookies?</h5>
                                        <p>Cookies are small text files that contain and save small pieces of information such as your language preference when you visit our website. These cookies are saved on your computer, tablet or smartphone when you visit our website. Cookies can contain person-identifying data, but this is not always the case. When you visit the website again at a later time, this cookie will send information to the website so the website recognizes your browser and can for example remember your language preference. Some cookies also allow use of certain functions on a website, or record how visitors to the web site use our website so we can use this information to optimize the website. Cookies often have an expiry date so they are automatically deleted after a certain time. Some cookies such as session cookies are immediately deleted after the browser is closed, while other cookies stay on your appliance for a longer time. We are required by law to ask for your permission to use some of these cookies. On this page you can read everything about which cookies we use and how we use them, and you can change your cookie preferences as you wish.</p>
                                        <h5>Types of cookies.</h5>
                                        <p>Cookies have a number of functions including remembering your preferences, recording visitor behaviour (web analytics) and for example to show relevant advertisements on other websites. We use our own first-party cookies and cookies from third parties or third-party cookies. Although we do not need permission to install cookies that are strictly required for the working of the website, a summary of all types of cookies with explanation is provided below.</p>
                                        <h5>Necessary cookies and preference cookies</h5>
                                        <p>These cookies are strictly required for the technical working of the website and ensure that a website can remember information that affects the behaviour and the form of the website, such as your preferred language or the region where you live. We do not require your permission for these cookies, also not if they originate from third parties that we use. These cookies have no impact on your privacy and are used anonymously.</p>
                                        <h5>Statistical cookies.</h5>
                                        <p>We use these cookies to analyse use of our websites so we can improve its functionality, quality and effectiveness. We need this knowledge to be able to adapt and improve our website. We then use the information to for example make sure that you can find certain parts more quickly. The statistics we collect cannot be traced back to individual persons. The visitor’s IP address is made anonymous.</p>
                                        <h5>Marketing cookies</h5>
                                        <p>With these cookies we record how you use our website and we try to help you choose a product that matches you best based on your website behaviour. We can then show products or services, personal recommendations and advertisements that may interest you. We may only install this type of cookie with your permission because these cookies are not strictly required for our website.</p>
                                        <p>You can at any time change or withdraw your consent from the Cookie Declaration on our website. Learn more about who we are, how you can contact us and how we process personal data in our <a style={{ color: "#272761" }}>Privacy Policy</a> Please state your consent ID and date when you contact us regarding your consent.</p> */}
                                        <p>Your consent applies to the following domains: <a style={{ color:"#272761"}}>www.Radius.com</a></p>
                                         
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setShowDetails(false)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CookiesConsentModal;
